"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchBar = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var constants_1 = require("utils/constants");
var clearSearchCross = function (props) {
    return (React.createElement("span", { className: 'file-list-search-box-right' }, props.tempValue !== '' && (React.createElement(Icon_1.Icon, { onClick: function () {
            props.setTempValue('');
            props.setSearchString('');
        }, className: "fa-times" }))));
};
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('tempValue', 'setTempValue', ''), (0, recompose_1.withState)('componentSearchValue', 'setComponentSearchValue', ''), recompose_1.pure);
var timeout = null;
exports.SearchBar = enhance(function (props) { return (React.createElement(sok_ui_1.TextInput, { value: props.tempValue, placeholder: props.placeHolder, className: "white", onChange: function (e) {
        var value = e.target.value;
        props.setTempValue(value);
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
            props.setSearchString(value);
        }, constants_1.SEARCH_TIMEOUT);
    }, icon: React.createElement(Icon_1.Icon, { className: 'fa-search' }), iconRight: clearSearchCross(props) })); });
